import { CURRENT_DEALER_ID_QUERY } from "features/common/queries";

export const getCurrentDealer = (cache) => {
  const data = cache.readQuery({ query: CURRENT_DEALER_ID_QUERY });
  return data?.currentDealer;
};

export const setCurrentDealer = (cache, id, name) => {
  cache.writeQuery({
    query: CURRENT_DEALER_ID_QUERY,
    data: {
      currentDealer: {
        id,
        name,
      },
    },
  });
};
